module.exports = __webpack_public_path__ + "static/media/Group9263.4da9949f.png";